module.exports = __webpack_public_path__ + "static/media/74580023-SsF0wSgs.96c13e7b.JPG";